"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1464))
 * @lastsynced 2026-10-29T13:52:14.201Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const HorizontalEllipsis = createSVGIcon(
  <path
    d="M21 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0M14 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0M7 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
    fill="currentColor"
  />,
  "HorizontalEllipsis",
  {
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
